"use client";

import { useEffect, useRef, useState } from 'react';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element?: HTMLElement, reload?: boolean) => void;
    };
  }
}

export default function TrustpilotWidget({ templateId }: { templateId: string }) {
  const [hasMounted, setHasMounted] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHasMounted(true);

    // Force Trustpilot to load/refresh widgets
    const loadTrustpilot = () => {
      if (typeof window !== 'undefined') {
        // If Trustpilot is already loaded, refresh widgets
        if (window.Trustpilot) {
          window.Trustpilot.loadFromElement(widgetRef.current ?? undefined, true);
          setScriptLoaded(true);
        } else {
          // Otherwise wait for script to load, poll every 100ms
          const checkInterval = setInterval(() => {
            if (window.Trustpilot) {
              window.Trustpilot.loadFromElement(widgetRef.current ?? undefined, true);
              setScriptLoaded(true);
              clearInterval(checkInterval);
            }
          }, 100);
        }
      }
    };

    // Small delay to ensure DOM is ready
    const timer = setTimeout(loadTrustpilot, 200);

    return () => clearTimeout(timer);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <div
      ref={widgetRef}
      className="trustpilot-widget"
      data-businessunit-id="69b46989a3e208775fa07074"
      data-template-id={templateId}
      data-style-height="100%"
      data-style-width="100%"
      data-theme="dark"
      data-locale="en-GB"
      data-review-languages="en"
      data-sku=""
      data-no-reviews="show"
      data-scroll-to-list="true"
      data-style-alignment="center"
    >
    </div>
  );
}
